
import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import UploadZone from './components/UploadZone';
import Stats from './components/Stats';
import Footer from './components/Footer';
import AdminLogin from './components/AdminLogin';
import ResultReport from './components/ResultReport';
import { SubmissionData, AnalysisResult } from './types';
import { analyzeQuotation } from './services/geminiService';

const App: React.FC = () => {
  const [analysisResult, setAnalysisResult] = useState<AnalysisResult | null>(null);
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleSuccess = async (data: SubmissionData) => {
    setIsAnalyzing(true);
    // Trigger Gemini analysis of the quote
    const result = await analyzeQuotation(data.fileName);
    setAnalysisResult(result);
    setIsAnalyzing(false);
    
    // Smooth scroll to the result report
    setTimeout(() => {
      const el = document.getElementById('result-report');
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  };

  return (
    <div className="min-h-screen bg-black text-white selection:bg-blue-500/30">
      {/* Cinematic Background elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[10%] left-[5%] w-[40vw] h-[40vw] bg-blue-900/10 blur-[150px] rounded-full"></div>
        <div className="absolute bottom-[10%] right-[5%] w-[30vw] h-[30vw] bg-emerald-900/10 blur-[150px] rounded-full"></div>
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-[0.03]"></div>
      </div>

      <Header onAdminClick={() => setShowAdminLogin(true)} />
      
      {showAdminLogin && <AdminLogin onClose={() => setShowAdminLogin(false)} />}

      <main className="relative">
        <Hero />
        
        <div className="max-w-6xl mx-auto">
          {/* Priority 1: The Upload Engine */}
          <div className="relative -mt-10 mb-20 z-10">
             <UploadZone onSuccess={handleSuccess} />
          </div>

          {analysisResult && (
            <div id="result-report" className="pb-20">
              <ResultReport result={analysisResult} />
            </div>
          )}

          {/* Social Proof & Context Follows */}
          <div className="space-y-32 pb-20">
            <Stats />
            <HowItWorks />

            <section className="px-8 text-center space-y-12 py-10">
              <h2 className="text-3xl md:text-4xl font-display font-black uppercase tracking-tighter italic">Savings Guaranteed Across All Brands</h2>
              <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16 grayscale opacity-40 hover:grayscale-0 hover:opacity-100 transition-all duration-700">
                <div className="text-xl md:text-2xl font-black italic tracking-tighter">MARUTI SUZUKI</div>
                <div className="text-xl md:text-2xl font-black italic tracking-tighter">HYUNDAI</div>
                <div className="text-xl md:text-2xl font-black italic tracking-tighter">TATA MOTORS</div>
                <div className="text-xl md:text-2xl font-black italic tracking-tighter">MAHINDRA</div>
                <div className="text-xl md:text-2xl font-black italic tracking-tighter">TOYOTA</div>
                <div className="text-xl md:text-2xl font-black italic tracking-tighter">KIA</div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default App;
